import { render, staticRenderFns } from "./tab_experiencia_profesional.vue?vue&type=template&id=37ee621f&scoped=true"
import script from "./tab_experiencia_profesional.vue?vue&type=script&lang=js"
export * from "./tab_experiencia_profesional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee621f",
  null
  
)

export default component.exports